import { render } from "./AthenaJobs.vue?vue&type=template&id=b2f942e8"
import script from "./AthenaJobs.vue?vue&type=script&lang=js"
export * from "./AthenaJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__